import { CSS, StyleProps } from "@shared/primitive-components"

export const tooltip = (): CSS => ({
  maxWidth: `200px`,
})

export const worstSpeedersContainer = (props: StyleProps): CSS => ({
  padding: props.theme.spacing(6),
  backgroundColor: props.theme.palette.white,
})

export const list = (): CSS => ({
  display: `flex`,
  paddingLeft: 0,
  "@media (max-width: 1250px)": {
    flexDirection: `column`,
  },
})

export const periodDate = (props: StyleProps): CSS => ({
  ...props.theme.fonts.subHeading,
  fontSize: props.theme.fontSize.caption,
  marginBottom: props.theme.spacing(2),
})
